export enum JobPositionStatus {
  Draft = 'Draft',
  Completed = 'Completed',
  Approved = 'Approved',
  Published = 'Published',
  Paused = 'Paused',
  Offline = 'Offline Match',
  Obsolete = 'Obsolete',
  CheckRequired = 'Check Required',
  AutomaticallyCreated = 'Automatically Created',
  AutomaticallyUpdated = 'Automatically Updated',
  InitiativePlaceholder = 'initiative_placeholder',
}

export const JOB_POSITION_STATUSES_WITH_REQUIRED_JOB_TITLES: string[] = [JobPositionStatus.Paused, JobPositionStatus.Published];
